const TensorflowLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="skill-icon"
    >
      <path
        d="M61.5501 128L39.7101 115.32V40.55L6.81006 59.56L6.89006 31.24L61.5501 0V128ZM66.4601 0V128L88.3001 115.32V79.31L104.79 88.84L104.69 64.21L88.3001 54.85V40.55L121.19 59.56L121.11 31.24L66.4601 0Z"
        fill="#00E96C"
      />
    </svg>
  );
};

export default TensorflowLogo;
